import { departmentDashboard } from '../actions/constant';
const {
  GET_DEPARTMENT_DASHBOARD_COUNT_REQUEST,
  GET_DEPARTMENT_PTO_REQUEST,
  GET_DEPARTMENT_THERAPY_MIN_REQUEST,
  UPDATE_DEPARTMENT_PTO_REQUEST,
  RESET_UPDATE_DEPARTMENT_PTO,
  CHECK_ASSIGN_TASK_PTO_REQUEST,
  CHECK_ASSIGN_TASK_PTO_RESET,
} = departmentDashboard;

export const getDepartmentDashboardCount = () => {
  return {
    type: GET_DEPARTMENT_DASHBOARD_COUNT_REQUEST,
  };
};
export const getDepartmentPto = (payload: any) => {
  return {
    type: GET_DEPARTMENT_PTO_REQUEST,
    payload,
  };
};
export const updateTherapyPto = (payload: any) => {
  return {
    type: UPDATE_DEPARTMENT_PTO_REQUEST,
    payload,
  };
};

export const getDepartmentTherapyMin = () => {
  return {
    type: GET_DEPARTMENT_THERAPY_MIN_REQUEST,
  };
};

export const resetDepartmentPTORequest = () => {
  return {
    type: RESET_UPDATE_DEPARTMENT_PTO,
  };
};

export const checkTaskAssignPTOAction = (payload: any) => {
  return {
    type: CHECK_ASSIGN_TASK_PTO_REQUEST,
    payload,
  };
};

export const checkTaskAssignPTORest = () => {
  return {
    type: CHECK_ASSIGN_TASK_PTO_RESET,
  };
};